export const FreShippingPageModes = {
  NEW: 'new',
  EDIT: 'edit',
} as const;

export type FreShippingPageModeType =
  typeof FreShippingPageModes[keyof typeof FreShippingPageModes];
